import React from 'react';
import { color_vars } from '~/src/utils/global_css';

export default function ColorPallete() {
  const colors = Object.entries(color_vars).sort(([a], [b]) => a.localeCompare(b));

  return (
    <>
      <h1>Peep Color Pallete</h1>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '.5rem' }}>
        {colors.map((c) => (
          <div style={{ display: 'flex', flexDirection: 'column', flexBasis: 1 }}>
            <div style={{ backgroundColor: c[1], width: '4rem', height: '4rem' }}></div>
            <span>{c[1]}</span>
            <span style={{ textWrap: 'pretty' }}>{c[0]}</span>
          </div>
        ))}
      </div>
    </>
  );
}
